<template>
  <div id="webLogin" class="website1">
    <!-- <div class="top_title fixed">登录/注册</div> -->
    <el-form :model="actionData" ref="form" :show-message="showMessage" @submit.native.prevent>
      <el-form-item prop="phone" :rules="rules.mobile">
        <el-input
          v-model="actionData.phone"
          type="tel"
          v-number-only
          maxlength="11"
          class="lwc_phone"
          placeholder="手机号码"
          ref="phone"
        ></el-input>
      </el-form-item>
      <el-form-item prop="code" key="code" :rules="rules.code">
        <div class="code_area">
          <el-input
            v-model="actionData.code"
            type="number"
            oninput="if(value.length > 6) value=value.slice(0, 6)"
            class="lwc_code"
            placeholder="短信验证码"
            ref="code"
          ></el-input>
          <el-button
            :class="{ lwc_primary: true, lwc_disabled: isdisabled }"
            :disabled="isdisabled"
            @click="sendCode"
            >{{ buttonName }}</el-button
          >
        </div>
      </el-form-item>
    </el-form>
    <div class="bottom">
      <div class="check">
        <van-popover
          v-model="showPopover"
          placement="top-start"
          get-container=".check"
        >
          <div class="check_popover">登录/注册前请先勾选</div>
        </van-popover>
        <el-checkbox v-model="actionData.agree"
          >同意 <span @click.prevent="gotoTarget(0)">《用户协议》</span>、
          <span @click.prevent="gotoTarget(1)">《隐私政策》</span>、
          <span @click.prevent="gotoTarget(2)"
            >《儿童个人信息保护规则及监护人须知》</span
          >和
          <span @click.prevent="gotoTarget(3)">《第三方服务共享清单》</span>
        </el-checkbox>
      </div>
      <el-button class="login_btn" :loading="loading" @click="login"
        >登录/注册</el-button
      >
      <img
        style="width: 60%; margin: 0 auto; display: block"
        src="../../assets/bx/login_logo.png"
        alt=""
      />
    </div>
  </div>
</template>
<script>
let hasPath;
let from_ju;
let from_app_key;
import $ from "jquery";
export default {
  data() {
    return {
      isdisabled: false,
      buttonName: "获取验证码",
      time: 58,
      type: "login",
      loading: false,
      actionData: {
        phone: "",
        code: "",
        agree: false,
      },
      showMessage: true,
      showPopover: false,
      list: ["agreement", "policy", "children", "thirdparty"],
    };
  },
  computed: {
    rules() {
      const { mobile, captcha, password } = this.$store.getters.rules;
      return {
        mobile: mobile,
        code: captcha,
        password,
      };
    },
    isAndroid() {
      var u = navigator.userAgent;
      if (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) {
        return true
      } else {
        return false
      }
    },
    isiOS() {
      var u = navigator.userAgent;
      var reg = new RegExp('WebView-iOS')
      if(u.match(reg)) {
        return true
      }else {
        return false
      }
    },
    platform() {
      if(this.$store.state.isApp) {
        if(this.isiOS) {
          return 2
        }else {
          return 1
        }
      }else {
        return 0
      }
    },
    sendData() {
      const sendData = {
        mobile: this.actionData.phone,
        code: this.actionData.code,
        platform: this.platform
      };
      return sendData;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
  },
  created() {
    this.$store.commit('resetinfo', {
      role_id: '',
      role_name: '',
    })
    this.$store.commit('resetServer')
    this.$store.commit('resetHomeServer')
    this.$store.commit('resetGameInfo')
  },
  methods: {
    //校验手机号
    checkPhone(num) {
      var reg =
        /^(13[\d]{9}$|^14[\d]{9}$|^15[\d]{9}$|^16[\d]{9}$|^17[\d]{9}$|^18[\d]{9}$|^19[\d]{9})$/;
      if (num == "") {
        return false;
      } else if (!reg.test(num)) {
        return false;
      } else {
        return true;
      }
    },
    //发送验证码
    sendCode() {
      var that = this;
      $(".lwc_code input").focus();
      if (this.checkPhone(this.actionData.phone)) {
        this.isdisabled = true;
        this.$Ajax("user-info/send-code", {
          action: this.type,
          mobile: this.actionData.phone,
        }).then(rs => {
          this.$toast({
            message: rs.msg,
            zIndex: 100000,
          });
          if (rs.code == 200) {
            that.buttonName = "重新发送(59)s";
            let interval = window.setInterval(function () {
              that.buttonName = "重新发送(" + that.time + ")s";
              that.time--;
              if (that.time < 0) {
                that.buttonName = "重新发送";
                that.time = 58;
                that.isdisabled = false;
                window.clearInterval(interval);
              }
            }, 1000);
          }else {
            that.buttonName = "重新发送";
            that.time = 58;
            that.isdisabled = false;
          }
        });
      } else {
        this.$refs.phone.handleBlur();
      }
    },
    //登录
    login() {
      var that = this;
      var api = "user-info/login";
      this.$refs.form.validate(valid => {
        this.showMessage = true;
        if (valid) {
          if (!this.actionData.agree) {
            this.showPopover = true;
            return;
          }
          this.loading = true;
          if(this.$route.query.ju) {
            this.sendData.user_id = this.$route.query.ju
          }
          if(this.$route.query.app_key) {
            this.sendData.app_key = this.$route.query.app_key
          }
          this.$Ajax(api, this.sendData)
            .then(rs => {
              if (rs.code == 200) {
                this.$store.dispatch("setCookies", rs.data);
                if (this.isAndroid) {
                  try {
                    window.android.sendUserInfoWebToNative(JSON.stringify(rs.data));
                  } catch (error) {
                    console.log(error);
                  }
                } else {
                  try {
                    window.webkit.messageHandlers.sendUserInfoWebToNative.postMessage(JSON.stringify(rs.data));
                  } catch (error) {
                    console.log(error);
                  }
                }
                this.$Message.success({
                  message: rs.msg,
                  duration: "2000",
                  onClose: () => {
                    if (hasPath && hasPath != "/user/login" && hasPath != '/') {
                      this.$router.go(-1)
                    } else {
                      var indexfrom = window.localStorage.getItem('indexfrom')
                      if(indexfrom && indexfrom != '') {
                        this.$router.push({
                          path: "/",
                          query: {
                            from: indexfrom
                          }
                        });
                      }else {
                        this.$router.push({
                          path: "/"
                        });
                      }
                    }
                  },
                });
              }else {
                this.$Message.error({
                  message: rs.msg
                })
                setTimeout(() => {
                  this.actionData.code = ''
                  this.$refs.code.focus()
                },1500)
              }
            })
            .finally(() => {
              setTimeout(() => {
                that.loading = false;
              }, 2000);
            });
        }
      });
    },
    gotoTarget(i) {
      this.$router.push({
        name: this.list[i],
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    hasPath = from.path;
    if(from.name == 'user.identity') {
      if(from.query.ju) {
        const query = Object.assign({}, to.query, { ju: from.query.ju,
          app_key: from.query.app_key });
        next(vm => {
          next({
          name: to.name,
          query
        })
        });
      }
    }else{
      next();
    }
    
  },
  watch: {
    "$route.query": {
      immediate: true,
      handler(e) {
        if (e.ju && e.app_key) {
          this.$Ajax(
            "user-info/find-userinfo",
            {
              juhe_user_id: e.ju,
              app_key: e.app_key,
            },
            "get"
          ).then(rs => {
            if (rs.code == 200) {
              this.$filterPop({
                type: "jhlogin",
                direction: "up",
                selection: {
                  path: hasPath
                }
              });
            } else if (rs.code == 201) {
              for (let key of ['access_token', 'refresh_token','userData','role_id','role_name','server_id','server_name']) {
                Cookies.remove(key)
                commit('state', {[key]: null})
              }
              window.localStorage.clear()
            } else if (rs.code == 202) {
              this.$Ajax("user-info/quick-register", {
                juhe_user_id: e.ju,
                app_key: e.app_key,
                platform: this.platform
              }).then(rs => {
                if (rs.code == 200) {
                  this.$store.dispatch("setCookies", rs.data);
                  this.$Message.success({
                    message: rs.msg,
                    duration: "2000",
                    onClose: () => {
                      this.$router.push({
                        path: "/",
                      });
                    },
                  });
                }
              });
            }
          });
        }
        if(e.app_key) {
          this.$Ajax('game/app-info-with-key',{app_key: e.app_key}).then(rs => {
            if(rs.code == 200) {
              this.$store.commit('setGameId',rs.data.id)
            }
          })
        }
      },
    },
  },
};
</script>
<style lang="less" scoped>
#webLogin {
  position: relative;
  padding-top: 1rem;
  .el-form {
    width: 100%;
    padding-top: 0.8rem;
    .el-form-item {
      margin-bottom: 2.5rem;
      /deep/ .el-form-item__error {
        font-size: 1.2rem;
      }
    }
  }

  /deep/.el-input__inner {
    height: 4.4rem;
    font-size: 1.4rem;
    padding: 0 1.6rem;
    outline: none;
    appearance: none;
  }
  .code_area {
    width: 100%;
    height: 4.4rem;
    display: flex;
    // border: 1px solid #dcdee6;
    // border-radius: 4px;
    position: relative;
    &:hover {
      border-color: #c0c4cc;
    }
    /deep/.el-input__inner {
      height: 100%;
      font-size: 1.4rem;
      padding: 0 1.6rem;
      padding-right: 10rem;
    }
    .lwc_primary {
      position: absolute;
      right: 0.6rem;
      top: 50%;
      transform: translateY(-50%);
      -webkit-tap-highlight-color: transparent;
      border: none;
      color: var(--theme);
      font-size: 1.2rem;
      background-color: var(--xq);
      color: #fff;
      width: 8.5rem;
      height: 2.5rem;
      line-height: 2.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      &:visited,
      &:hover,
      &:active {
        opacity: 0.9;
      }

      &.is-disabled {
        background-color: #999;
      }
    }
  }
  .psd_area {
    width: 100%;
    border: 1px solid #dcdee6;
    &:hover {
      border-color: #c0c4cc;
    }
    .lwc_password {
      width: 100%;
      /deep/.el-input__inner {
        width: 100%;
        height: calc(4.4rem - 2px);
        font-size: 1.4rem;
        padding: 0 1.6rem;
        outline: none;
        appearance: none;
        border: none;
      }
    }
  }
  .login_btn {
    margin-top: 2.2rem;
    width: 100%;
    border: none;
    background-color: var(--theme);
    color: #fff;
    height: 3rem;
    font-size: 1.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10rem;
    &:active {
      opacity: 0.9;
    }
  }
  .change_type {
    margin-top: 1.5rem;
    font-size: 1.3rem;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
  .bottom {
    // position: absolute;
    // bottom: 2rem;
    // left: 0;
    // width: 100%;
    margin-top: 30vh;
    padding: 0 1.2rem;
  }
  .check {
    overflow: hidden;
    /deep/.el-checkbox {
      align-items: flex-start;
      .el-checkbox__label {
        font-size: 1.3rem;
        line-height: 1.8rem;
        span {
          color: var(--theme);
        }
      }
    }
  }
}
@media screen and (orientation: landscape) {
  .bottom {
    position: unset !important;
    margin: 2rem 0;
  }
}
</style>